import { render, staticRenderFns } from "./employeeInductionAction.vue?vue&type=template&id=2668d5f2&scoped=true"
import script from "./employeeInductionAction.vue?vue&type=script&lang=js"
export * from "./employeeInductionAction.vue?vue&type=script&lang=js"
import style0 from "./employeeInductionAction.vue?vue&type=style&index=0&id=2668d5f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2668d5f2",
  null
  
)

export default component.exports